/* eslint-disable import/prefer-default-export */
export const isClient = () => typeof (Storage) !== 'undefined';
